import { useEffect, useState } from 'react';
import { META_KEYS } from '../database/offlineDatabase/types/offlineDatabaseMeta.types';
import { offlineMetaRepository } from '../repositories/offlineMeta.repository';

const useCanEnterInOfflineMode = () => {
  const [disabled, setDisabled] = useState(true);

  useEffect(() => {
    const check = async () => {
      const meta = await offlineMetaRepository.getByKey(META_KEYS.canEnterInOfflineMode);
      setDisabled(!meta?.value);
    };

    check();
  }, []);

  return { canEnterInOfflineMode: !disabled };
};

export default useCanEnterInOfflineMode;
